module.exports = __webpack_public_path__ + "img/daizy_bridge.2d29d841.jpg";